import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { csvFilterChip } from './csvFilterChip';

// DataTable kolonuna seçim süzgeci (mui-datatables `custom` filterType + MUI Select — çalışanlar ve
// KVKK listeleriyle aynı görünüm). Kolonun `options`ına yayılır:
//   options: { filter: true, sort: true, ...selectFilterOptions({ label, options, filterKey }) }
//
// `options`: [{ value, label }]. `value` dizgeye çevrilerek gönderilir.
// `multiple: true` → değerler virgülle ayrık tek parametre (`filterKey`, ör. `status[in]`); çip
//   çevrilmiş etiketleri gösterir (csvFilterChip). Değerler virgül İÇERMEMELİ (kimlik, sayı, kod).
// `multiple: false` → tek değer (`filterKey`, ör. `category[eq]`); serbest metin değerler için.
//
// `filterKey` backend sorgu adıdır (parseTableParams onu kolon adının yerine gönderir) — kolon adı
// görüntülenen alanı (`categoryName`), süzgeç kimliği (`categoryId[in]`) taşıyabilsin diye.
export function selectFilterOptions({ label, options, filterKey, multiple = false }) {
  const labelOf = (v) => options.find((o) => String(o.value) === String(v))?.label ?? v;

  const display = (filterList, onChange, index, column) => {
    const raw = filterList[index] && filterList[index][0] != null ? String(filterList[index][0]) : '';
    const apply = (next) => {
      filterList[index] = next ? [next] : [];
      onChange(filterList[index], index, column);
    };

    if (multiple) {
      const current = raw ? raw.split(',').filter(Boolean) : [];
      return (
        <FormControl variant="standard" fullWidth>
          <InputLabel>{label}</InputLabel>
          <Select
            multiple
            value={current}
            onChange={(e) => {
              const v = e.target.value;
              apply(Array.isArray(v) ? v.filter(Boolean).join(',') : '');
            }}
            renderValue={(sel) => sel.map(labelOf).join(', ')}
          >
            {options.map((o) => (
              <MenuItem key={String(o.value)} value={String(o.value)}>{o.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }

    return (
      <FormControl variant="standard" fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select value={raw} onChange={(e) => apply(e.target.value)}>
          <MenuItem value=""><em>-</em></MenuItem>
          {options.map((o) => (
            <MenuItem key={String(o.value)} value={String(o.value)}>{o.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  return {
    filterType: 'custom',
    customFilterListOptions: multiple
      ? csvFilterChip(label, labelOf)
      : { render: (v) => (v && v[0] ? [`${label}: ${labelOf(v[0])}`] : []) },
    filterOptions: { filterKey, display },
  };
}

export default selectFilterOptions;
